import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { ProveedorDTO } from "src/app/models/dto/proveedor.dto";
import { PlantasDTO } from "src/app/models/plantas.dto";

@Component({
  selector: "app-form-drawer-proveedor",
  templateUrl: "./drawer-form.component.html",
})
export class ProveedorDrawerForm
  extends CrudForm<ProveedorDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: ProveedorDTO;
  };
  constructor(
    public fb: FormBuilder,
  ) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
    public fromInit(row: ProveedorDTO) {
      this.form.controls["IdProveedor"].setValue(row?.IdProveedor);
      this.form.controls["Nombre"].patchValue(row?.Nombre);
      this.form.controls["Direccion"].setValue(row?.Direccion);
    }

    protected buildForm() {
      this.form = this.fb.group({
        IdProveedor: [""],
        Nombre: [""],
        Direccion: [""],
      });
    }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }

}
